
















import { Vue, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component

export default class BasketToaster extends Vue {
    @Prop({
        required: true,
        type: Boolean,
        default: false
    }) show!: boolean;

    @Prop({
        required: false,
        type: String,
        default: ''
    }) headline!: string;

    @Prop({
        required: false,
        type: String,
        default: ''
    }) description!: string;

    @Prop({
        required: false,
        type: Boolean,
        default: false
    }) warning!: boolean;
}
